import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { ConatinerHookloaderMappingApi } from "../../../Apis/TransferStationReport/containerHookloaderMappingApi";
import TableComponent from "../../../Common/TableComponent/tableComponent";
import * as XLSX from "xlsx";
import ExcelJS from "exceljs";
import isGHMC, { getCurrentDateTime1 } from "../../../Common/helper/helpar";
import { getNowDateTime, getOneMonthPastDateTime } from "../../AssetVehicle/utils/helpers";
const ContainerHookLoaderMappingTrabsaction = ({ t }) => {
  const headers = [
    // "hookloaderUid",
    // "containerUid",
    "vehicleNumber",
    "vehicleType",
    "ownerType",
    "tsincharge",
    "tsname",
    "deploymentDate",
    "latitude",
    "longitude",
    "address",
    "image",
  ];

  const [getAllTripsTonnage, setAllTripsTonnage] = useState([]);
  const [startDate, setStartDate] = useState(getStartOfCurrentDate());
  const [endDate, setEndDate] = useState(getCurrentDateTime());
  const [VehicleNumber, setVehicleNumber] = useState("");
  const isProd = isGHMC();
  useEffect(() => {
    fetchTripsTonnageData(startDate, endDate);
  }, []);

  const fetchTripsTonnageData = async (startDate, endDate,VechicleNumber) => {
    try {
      const response = await ConatinerHookloaderMappingApi(startDate, endDate,VechicleNumber);
      const formattedData = response.data.map((item) => ({
        ...item,
        image: item.scannedImageUrl, // Include vehicleImageUrl in the data
        tsincharge: item.transferStationInchargeName || "N/A",
        containerUid: item.containerUuid|| "N/A",
        tsname: item.transferStationName|| "N/A",
        hookloaderUid: item.hookloaderUuid|| "N/A",
        latitude: item.scannedLatitude|| "N/A",
        longitude: item.scannedLongitude|| "N/A",
        deploymentDate: item.scannedDate|| "N/A",
        vehicleType:item.vehicleTypeName|| "N/A",
        ownerType:item.ownerTypeName || "N/A"
        // afterImage: item.afterImageUrl|| "N/A",
      }));
      setAllTripsTonnage(formattedData);
    } catch (error) {}
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    fetchTripsTonnageData(startDate, endDate,VehicleNumber);
  };

  //   const fetchShiftDetails = async () => {
  //     const [secondaryCollectionReport] = await Promise.all([AllSecondaryDeploymentReport()]);
  //     const shiftData = secondaryCollectionReport.map((station) => {
  //       return {
  //         ...station,
  //         shift: station.shiftName, // Assuming the API response has a key named shiftName for shift names
  //         image:station.vehicleImageUrl,
  //         status: station.isActive ? "Active" : "InActive"
  //       };
  //     });
  //     // setShiftName(shiftData);
  //   };

  //   useEffect(() => {
  //     fetchShiftDetails();
  //   }, []);

  const options = { day: "numeric", month: "numeric", year: "numeric" };
  const generationTime = ` ${new Date()
    .toLocaleString("en-GB", options)
    .replace(/\//g, "/")}`;
  const formatDateForDisplay = (dateString) => {
    const date = new Date(dateString);
    const options = { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" };
    return date.toLocaleString("en-GB", options).replace(",", "");
  };


  const downloadAsExcel = async () => {
    // Create a new workbook and add a worksheet
    const currentDate = new Date();
    const formattedDate = `${currentDate.getDate()}-${
      currentDate.getMonth() + 1
    }-${currentDate.getFullYear()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const cumulativeHeadingReport = `Container Hookloader Transaction Reports (${formatDateForDisplay(startDate)} to ${formatDateForDisplay(endDate)}) (at ${getCurrentDateTime1()})`;
    const downloadDateTime = `Report on: ${generationTime},${formattedTime}`;
    // Calculate the length of the downloadDateTime string
    const downloadDateTimeLength = downloadDateTime.length;
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Zones");
    // Define styles
    const boldFont = { bold: true };

    // Add the downloadDateTime to the correct row and columns, and ensure formatting
    worksheet.addRow(["", "", downloadDateTime, ""]); // Update array length to match new cell range
    worksheet.mergeCells(1, 2, 1, 9); // Merge cells for downloadDateTime from column 2 to 4
    worksheet.getCell(1, 2).value = downloadDateTime; // Ensure the value is set after merging
    worksheet.getCell(1, 2).font = boldFont; // Set font style
    worksheet.getCell(1, 2).alignment = { horizontal: "center" }; // Center align the content

    // Apply styles to the merged cells (B1, C1, D1)
    for (let col = 2; col <= 9; col++) {
      worksheet.getCell(1, col).font = boldFont; // Set styles individually
      worksheet.getCell(1, col).alignment = { horizontal: "center" }; // Center align the cell content
    }

    // Add "Zone Details" to the correct row and columns, and ensure formatting
    worksheet.addRow(["", "", cumulativeHeadingReport, ""]); // Update array length to match new cell range
    worksheet.mergeCells(2, 2, 2, 9); // Merge cells for Zone Details from column 2 to 4
    worksheet.getCell(2, 2).value = cumulativeHeadingReport; // Ensure the value is set after merging
    worksheet.getCell(2, 2).font = boldFont; // Set font style
    worksheet.getCell(2, 2).alignment = { horizontal: "center" }; // Center align the content

    // Apply styles to the merged cells (B2, C2, D2)
    for (let col = 2; col <= 9; col++) {
      worksheet.getCell(2, col).font = boldFont; // Set styles individually
      worksheet.getCell(2, col).alignment = { horizontal: "center" }; // Center align the cell content
    }

    // Add empty row for spacing
    worksheet.addRow([""]);

    // Add table header row with bold font
    const tableHeaderRow = worksheet.addRow([
      "S.No",
      // "HookLoader UID",
      // "Container UID",
      "Vehicle Number",
      "Vehicle Type",
      "Owner Type",
      "Ts Incharge",
      "TS Name",
      "Deployment Date",
      "Latitude",
      "Longitude",
      "Address",
    ]);

    tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      cell.font = boldFont;
      cell.alignment = { horizontal: "left" }; // Left align the cell content
      if (colNumber >= 1 && colNumber <= 13) {
        // Apply background color only to specific cells
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "F6B1B1" }, // Red background color
        };
      }
    });

    // Add data rows
    getAllTripsTonnage.forEach((item, index) => {
      worksheet
        .addRow([
          index + 1,
          // item.hookloaderUuid?? "N/A",
          // item.containerUuid?? "N/A",
          item.vehicleNumber?? "N/A",
          item.vehicleTypeName?? "N/A",
          item.ownerTypeName?? "N/A",
          item.transferStationInchargeName?? "N/A",
          item.transferStationName?? "N/A",
          item.scannedDate?? "N/A",
          item.scannedLatitude?? "N/A",
          item.scannedLongitude?? "N/A",
          item.address?? "N/A",
        ])
        .eachCell({ includeEmpty: true }, (cell, colNumber) => {
          if (colNumber >= 1 && colNumber <= 13) {
            // Align the columns from 1 to 4 to the left
            cell.alignment = { horizontal: "left", vertical: 'middle', wrapText: true };
          } else {
            // Align the rest of the columns to the center
            cell.alignment = { horizontal: "center", vertical: 'middle', wrapText: true };
          }
        });
    });

    // Set column widths dynamically based on content
    worksheet.columns = [
      { width: 5 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 100 },
    ];

    // Save the workbook to a file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "ContainerHookLoaderTransactionReport.xlsx";
    a.click();
    URL.revokeObjectURL(url);
  };
  return (
    <>
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
            <h4 class="text-start mb-3">
              {t("Container Hookloader Transaction Report")} ({formatDateForDisplay(startDate)} to {formatDateForDisplay(endDate)}) (at {getCurrentDateTime1()})
            </h4>
            <div className="card">
              <div className="card-body p-3">
                <div className="row align-items-end ">
                  <div className="col-md-10">
                    <form onSubmit={handleFormSubmit}>
                      <div className="row" style={{ textAlign: "left" }}>
                        <div className="col-md-3">
                          <label>From Date & Time:</label>
                          <input
                            type="datetime-local"
                            name="FromDate"
                            style={inputStyle}
                            value={startDate}
                            className="form-control"
                            min={getOneMonthPastDateTime()}
                            max={getNowDateTime()}                          
                           onChange={(e) => setStartDate(e.target.value)}
                          />
                        </div>
                        <div className="col-md-3">
                          <label>To Date & Time:</label>
                          <input
                            type="datetime-local"
                            name="ToDate"
                            style={inputStyle}
                            value={endDate}
                            className="form-control"
                            min={startDate}
                            max={getCurrentDateTime()}
                            onChange={(e) => setEndDate(e.target.value)}
                          />
                        </div>
                        <div className="col-md-3">
                          <label>Vehicle Number</label>
                          <input
                            type="text"
                            name="vehicleTypeCode"
                            style={FilterInputStyle}
                            placeholder="Vehicle Number"
                            value={VehicleNumber}
                            onChange={(e) => {
                              setVehicleNumber(
                                e.target.value.replace(/\s+/g, "")
                              );
                            }}
                          />
                        </div>
                        <div className="col-md-3">
                          <button
                            type="submit"
                            className={`btn mt-4 ${
                              isProd ? "search-ghmc" : "search-swm"
                            }`}
                          >
                            Search
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                  <div className="col-md-2">
                    <button
                      className="btn btn-excel ms-auto"
                      onClick={downloadAsExcel}
                    >
                      <i class="fa-solid fa-file-excel me-1 icon-container"></i>{" "}
                      Excel
                    </button>
                  </div>
                </div>
                <div className="mt-3">
                  <TableComponent
                    DataFetchURL={getAllTripsTonnage}
                    headers={headers}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

// Function to get the start of the current date (00:00 AM)
const getStartOfCurrentDate = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}T00:00`;
};

// Function to get current date and time in the required format
const getCurrentDateTime = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  const hour = String(now.getHours()).padStart(2, "0");
  const minute = String(now.getMinutes()).padStart(2, "0");
  return `${year}-${month}-${day}T${hour}:${minute}`;
};

// Styles for input and button
const inputStyle = {
  border: "1px solid #E2E2E2",
  // padding: "15px",
};
const FilterInputStyle = {
  height: "38px",
  borderRadius: "4px",
  border: "1px solid #ced4da",
  paddingLeft: "10px",
  width: "100%",
};

const buttonStyle = {
  color: "#fff",
};

export default withTranslation()(ContainerHookLoaderMappingTrabsaction);
